import { createContext } from 'react';

import { env } from '@/env';

export const TimezoneContext = createContext(env.NEXT_PUBLIC_TIMEZONE);
